'use client';

import { SurfaceContext, SurfaceType } from 'contexts/SurfaceContext';
import { useState } from 'react';

export function SurfaceProvider({ children }: { children: React.ReactNode }) {
  const [surface, setSurface] = useState<SurfaceType>('neutral');
  return (
    <SurfaceContext.Provider
      value={{
        value: surface,
        setValue: setSurface,
      }}
    >
      {children}
    </SurfaceContext.Provider>
  );
}
